module.exports = __webpack_public_path__ + "img/42.cae57417.svg";